export default __webpack_public_path__ + "static/coaching_symbol-307f997db48ef4ed0d6b566fcab73ba9.svg";